<template>
  <div class="customerContainer">
    <ul v-if="detailVal != ''" class="content">
      <li>
        <label>日期：</label>
        <p>
          {{
            detailVal.create_time == undefined
              ? ""
              : detailVal.create_time.substring(0, 10)
          }}
        </p>
      </li>
      <li>
        <label>运营姓名：</label>
        <p>{{ detailVal.visit_user_name }}</p>
      </li>
      <li>
        <label>拜访合作商姓名：</label>
        <p>{{ detailVal.customer_user_name }}</p>
      </li>
      <li v-show="detail.service_type != 0">
        <label>类型：</label>
        <p v-show="detail.service_type == 1">甲方客户</p>
        <p v-show="detail.service_type == 2">劳务经纪</p>
      </li>
      <li v-show="detail.service_type == 2">
        <label>劳务经纪类型：</label>
        <p v-show="detail.labour_type == 1">个人</p>
        <p v-show="detail.labour_type == 2">公司</p>
      </li>
      <li v-show="detail.service_type == 2 && detail.labour_type == 2">
        <label>劳务经纪公司名称：</label>
        <p>{{ detail.labour_company }}</p>
      </li>
      <li>
        <label>岗位：</label>
        <span v-for="(element, j) in detailVal.customer_role_info" :key="j">
          <p v-show="j > 0">&nbsp;|&nbsp;</p>
          <p>{{ element.role_name }}</p>
        </span>
      </li>
      <li>
        <label>项目：</label>
        <p>{{ detailVal.project_name }}</p>
      </li>
      <li>
        <label>拜访类型：</label>
        <p v-if="detailVal.visit_type == 1">电话</p>
        <p v-else-if="detailVal.visit_type == 2">面访</p>
        <p v-else>社交APP</p>
      </li>
      <li>
        <label>沟通：</label>
        <p>{{ detailVal.communicate }}</p>
      </li>
    </ul>
    <div class="tableStyle">
      <h2>沟通记录：</h2>
      <table>
        <thead>
          <th>日期</th>
          <th>运营姓名</th>
          <th>拜访合作商姓名</th>
          <!-- <th>岗位</th> -->
          <th>项目</th>
          <th>拜访类型</th>
          <th>沟通</th>
        </thead>
        <tbody>
          <tr v-for="(element, i) in detailVal.communicate_record" :key="i">
            <td>{{ element.create_time.substring(0, 10) }}</td>
            <td>{{ element.visit_user_name }}</td>
            <td>{{ element.customer_user_name }}</td>
            <!-- <td>
              <span v-for="(item,j) in element.customer_role_info" :key="j">
                <p>{{item}}</p>
                <p v-show="j>0">&nbsp|&nbsp</p>
                <p>{{item.role_name}}</p>
              </span>
            </td> -->
            <td>{{ element.project_name }}</td>
            <td>
              <p v-if="element.visit_type == 1">电话</p>
              <p v-else-if="element.visit_type == 2">面访</p>
              <p v-else>社交APP</p>
            </td>
            <td style="width:40%">
              <p>{{ element.communicate }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detailVal: {}
    };
  },
  props: {
    detail: {}
  },
  watch: {
    detail() {
      this.detailVal = this.detail;
      // console.log(this.detailVal);
    }
  },
  mounted() {
    if (this.detail != undefined) {
      this.detailVal = this.detail;
    }
  }
};
</script>
<style lang="less" scoped>
.customerContainer {
  padding: 30px 4%;
  .content {
    li {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 10px;
      p,
      label,
      span {
        display: inline-block;
        font-size: 14px;
      }
    }
  }
  .tableStyle {
    margin-top: 20px;
    h2 {
      margin-bottom: 10px;
    }

    p {
      line-height: 20px;
    }
    th,
    td {
      padding: 4px 6px;
      font-size: 12px;
      border: 1px solid #ccc;
    }
  }
}
</style>
